import React from 'react';
import { TreeLayerProps } from './tree-types';

export function TreeLayer<T>({ childNodes, depth, getTreeNodeComponent }: TreeLayerProps<T>) {
	return (
		<>
			{childNodes.map(node => {
				const NodeComponent = getTreeNodeComponent(node);

				return (
					<NodeComponent
						key={node.id}
						node={node}
						depth={depth + 1}
						getTreeNodeComponent={getTreeNodeComponent}
					/>
				);
			})}
		</>
	);
}
